import { SmartListTemplate } from '@/types/smartList'

export const SMART_LIST_TEMPLATES: SmartListTemplate[] = [
  // Popular Templates
  {
    id: 'recent-expenses',
    name: 'Recent Expenses',
    description: 'All expenses from the last 30 days',
    icon: 'TrendingDown',
    color: '#E53935',
    category: 'expense',
    isPopular: true,
    filters: {
      type: 'expense',
      dateRange: 'thisMonth'
    }
  },
  {
    id: 'large-transactions',
    name: 'Large Transactions',
    description: 'Transactions over $500 for tracking significant spending',
    icon: 'DollarSign',
    color: '#FF9800',
    category: 'analysis',
    isPopular: true,
    filters: {
      minAmount: 500
    }
  },
  {
    id: 'monthly-income',
    name: 'Monthly Income',
    description: 'All income sources for this month',
    icon: 'TrendingUp',
    color: '#439476',
    category: 'income',
    isPopular: true,
    filters: {
      type: 'income',
      dateRange: 'thisMonth'
    }
  },

  // Expense Categories
  {
    id: 'food-dining',
    name: 'Food & Dining',
    description: 'Restaurant meals, groceries, and food delivery',
    icon: 'UtensilsCrossed',
    color: '#FF5722',
    category: 'expense',
    filters: {
      type: 'expense',
      search: 'food'
    }
  },
  {
    id: 'transportation',
    name: 'Transportation',
    description: 'Gas, parking, ride-shares, and travel expenses',
    icon: 'Car',
    color: '#2196F3',
    category: 'expense',
    filters: {
      type: 'expense',
      search: 'gas'
    }
  },
  {
    id: 'entertainment',
    name: 'Entertainment',
    description: 'Movies, streaming, games, and leisure activities',
    icon: 'Gamepad2',
    color: '#9C27B0',
    category: 'expense',
    filters: {
      type: 'expense',
      search: 'entertainment'
    }
  },
  {
    id: 'shopping',
    name: 'Shopping',
    description: 'Online purchases, retail, and personal items',
    icon: 'ShoppingBag',
    color: '#FF4081',
    category: 'expense',
    filters: {
      type: 'expense',
      search: 'shopping'
    }
  },

  // Savings & Investment
  {
    id: 'savings-transfers',
    name: 'Savings Transfers',
    description: 'Money moved to savings and investment accounts',
    icon: 'PiggyBank',
    color: '#4CAF50',
    category: 'savings',
    filters: {
      type: 'transfer',
      search: 'savings'
    }
  },
  {
    id: 'investments',
    name: 'Investments',
    description: 'Stock purchases, retirement contributions, and investments',
    icon: 'TrendingUp',
    color: '#00BCD4',
    category: 'savings',
    filters: {
      search: 'investment'
    }
  },

  // Analysis Templates
  {
    id: 'weekly-spending',
    name: 'This Week\'s Spending',
    description: 'All expenses from the current week',
    icon: 'Calendar',
    color: '#6366F1',
    category: 'analysis',
    filters: {
      type: 'expense',
      dateRange: 'thisWeek'
    }
  },
  {
    id: 'quarterly-review',
    name: 'Quarterly Review',
    description: 'All transactions from this quarter for analysis',
    icon: 'BarChart2',
    color: '#8E24AA',
    category: 'analysis',
    filters: {
      dateRange: 'thisMonth'
    }
  },
  {
    id: 'cash-transactions',
    name: 'Cash Transactions',
    description: 'Track cash spending and withdrawals',
    icon: 'Banknote',
    color: '#795548',
    category: 'analysis',
    filters: {
      search: 'cash'
    }
  },
  {
    id: 'pending-transactions',
    name: 'Pending Transactions',
    description: 'Transactions that need review or are still processing',
    icon: 'Clock',
    color: '#FF9800',
    category: 'analysis',
    filters: {
      status: 'pending'
    }
  },

  // Specialized Templates
  {
    id: 'business-expenses',
    name: 'Business Expenses',
    description: 'Work-related expenses for tax deductions',
    icon: 'Briefcase',
    color: '#455A64',
    category: 'expense',
    filters: {
      type: 'expense',
      tags: ['business', 'work', 'tax-deductible']
    }
  },
  {
    id: 'subscriptions',
    name: 'Subscriptions',
    description: 'Recurring subscription payments',
    icon: 'RefreshCw',
    color: '#673AB7',
    category: 'expense',
    filters: {
      type: 'expense',
      search: 'subscription',
      tags: ['subscription', 'recurring']
    }
  },
  {
    id: 'holiday-spending',
    name: 'Holiday Spending',
    description: 'Gift purchases and holiday-related expenses',
    icon: 'Gift',
    color: '#F44336',
    category: 'expense',
    filters: {
      type: 'expense',
      tags: ['holiday', 'gift', 'christmas', 'birthday']
    }
  }
]

export const TEMPLATE_CATEGORIES = [
  { id: 'expense', name: 'Expenses', icon: 'TrendingDown', color: '#E53935' },
  { id: 'income', name: 'Income', icon: 'TrendingUp', color: '#439476' },
  { id: 'savings', name: 'Savings', icon: 'PiggyBank', color: '#4CAF50' },
  { id: 'analysis', name: 'Analysis', icon: 'BarChart2', color: '#6366F1' },
  { id: 'custom', name: 'Custom', icon: 'Settings', color: '#757575' }
] as const

export function getTemplatesByCategory(category: string) {
  return SMART_LIST_TEMPLATES.filter(template => template.category === category)
}

export function getPopularTemplates() {
  return SMART_LIST_TEMPLATES.filter(template => template.isPopular)
}

export function getTemplateById(id: string) {
  return SMART_LIST_TEMPLATES.find(template => template.id === id)
} 